<app-common-bulk-select-employee-dialog
    #selectEmployees
    headerText="time-tracking.addOrRemoveEmployees"
    [label]="'select' | appTranslate"
    [additionalQueryFilters]="[whereOnTimeTrackingAndPayroll]"
>
    <p class="align-left margin-top-2 margin-bottom-4">
        {{ 'time-tracking.payrollIntegrationPage.employeeSelectExplanation' | translate }}
    </p>
</app-common-bulk-select-employee-dialog>

<div *ngIf="employees.length > 0">
    <div class="flex align-center space-between middle margin-y-3">
        <app-search #searchBar placeholder="search" (onSearch)="onSearch($event)"></app-search>
    </div>
    <app-simple-table
        *ngIf="rows.length > 0"
        [attr.data-cy]="'assigned-employees-projects-table'"
        [columns]="columns"
        [rows]="rows"
        [sticky]="true"
        [fixedHeight]="true"
        [showMeatballs]="true"
        [showEditItem]="false"
        (deleteClicked)="removeEmployeeByIndex($event)"
        [deleteText]="'time-tracking.remove'"
    ></app-simple-table>
</div>

<div [class.loading]="isLoading">
    <!-- there are no employees -->
    <ng-container *ngIf="employees.length === 0">
        <p class="margin-top-4 empty-text">
            {{ 'time-tracking.payrollIntegrationPage.noEmployeesSelected' | translate }}
        </p>
    </ng-container>
    <!-- there are employees, but none match search query -->
    <app-empty-state
        *ngIf="employees.length > 0 && rows.length === 0"
        [label]="'time-tracking.payrollIntegrationPage.noFilteredEmployeesOnPayrollIntegration' | translate"
        src="/assets/illustrations/magnifying-glass.png"
    ></app-empty-state>
    <ui-button class="margin-top-4" (click)="openEmployeeSelect()" type="outline">{{
        'time-tracking.addOrRemoveEmployees' | appTranslate
    }}</ui-button>
</div>
